import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable, Subject } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  headers:HttpHeaders = new HttpHeaders({});

  constructor(public http: HttpClient, public cookieService:CookieService) { 
    
  }

  getToken(){
    this.setHeaders()
    return this.http.get<any>(`${environment.apiUrl}/api/GetTokenNinas/AppNina/Nina4pp+SS`, {headers: this.headers})
  }

  getSucursales(data:any){
    this.setHeaders()
    return this.http.get<any>(`${environment.apiUrl}/api/getSucursales/${data.token}`, {headers: this.headers})
  }


  getLineas(data:any){
    this.setHeaders()
    return this.http.get<any>(`${environment.apiUrl}/api/getAppLineas/${data.token}`, {headers: this.headers})
  }

  getLineasSucursal(data:any){
    this.setHeaders()
    return this.http.get<any>(`${environment.apiUrl}/api/getAppLineaPorIdSucursal/${data.token}/${data.idSucursal}`, {headers: this.headers})
  }

  getProductosTotales(data:any){
    this.setHeaders()
    return this.http.get<any>(`${environment.apiUrl}/api/getProductosTotals/${data.token}`, {headers: this.headers})
  }

  getProductoAgrupador(data:any){
    this.setHeaders()
    return this.http.get<any>(`${environment.apiUrl}/api/getAppProductoAgrupador/${data.token}`, {headers: this.headers})
  }

  getProductoAgrupadorId(data:any){
    this.setHeaders()
    return this.http.get<any>(`${environment.apiUrl}/api/getAppProductoAgrupadorPorId/${data.token}/${data.idAgrupadorProd}`, {headers: this.headers})
  }

  getProductos(data:any){
    this.setHeaders()
    return this.http.get<any>(`${environment.apiUrl}/api/getAppProducto/${data.token}`, {headers: this.headers})
  }
  
  getProductoPorProductoAgrupador(data:any){
    this.setHeaders()
    // El ID es el agrupador
    return this.http.get<any>(`${environment.apiUrl}/api/getAppProductoPorId/${data.token}/${data.idAgrupadorProd}`, {headers: this.headers})
  }

  getBanners(data:any){
    this.setHeaders()
    return this.http.get<any>(`${environment.apiUrl}/api/getBanners/${data.token}`, {headers: this.headers})
  }

  getSucursalesPorProducto(data:any){
    this.setHeaders()
    return this.http.get<any>(`${environment.apiUrl}/api/getSucursalesPorIdProductos/${data.token}/${data.idProducto}`, {headers: this.headers})
  }

  getSucursalesPorProductoSegunCantidadSolicitada(data:any){
    this.setHeaders()
    return this.http.get<any>(`${environment.apiUrl}/api/getSucursalesPorIdProductosSegunCantidadSolicitada/${data.token}/${data.idProducto}/${data.qty}`, {headers: this.headers})
  }

  getSucursalesPorProductoAgrupador(data:any){
    this.setHeaders()
    return this.http.get<any>(`${environment.apiUrl}/api/getSucursalesPorIdProductoAgrupador/${data.token}/${data.idAgrupadorProd}`, {headers: this.headers})
  }

  getSucursalesPorLinea(data:any){
    this.setHeaders()
    return this.http.get<any>(`${environment.apiUrl}/api/getSucursalesPorIdLineaApps/${data.token}/${data.idLineaApp}`, {headers: this.headers})
  }

  getProdutosAgrupadoresPorSucursal(data:any){
    this.setHeaders()
    return this.http.get<any>(`${environment.apiUrl}/api/getAppProductoAgrupadorPorIdSucursal/${data.token}/${data.idSucursal}`, {headers: this.headers})
  }

  getProductosAgrupadoresPorSucursalYLinea(data:any){
    this.setHeaders()
    return this.http.get<any>(`${environment.apiUrl}/api/getAppProductoAgrupadorPorIdSucursal_IdLinea/${data.token}/${data.idSucursal}/${data.idLineaApp}`, {headers: this.headers})
  }

  getProductosPorSucursalYProductoAgrupador(data:any){
    this.setHeaders()
    return this.http.get<any>(`${environment.apiUrl}/api/getAppProductoPorIdSucursal_IdProductoAgrupador/${data.token}/${data.idSucursal}/${data.idAgrupadorProd}`, {headers: this.headers})
  }

  getProductosPorSucursal(data:any){
    this.setHeaders()
    return this.http.get<any>(`${environment.apiUrl}/api/getAppProductoPorIdSucursal/${data.token}/${data.idSucursal}`, {headers: this.headers})
  }

  solicitaApartado(data:any){
    this.setHeaders()
    return this.http.post<any>(`${environment.apiUrl}/api/solicitaApartado`, data, {headers: this.headers})
  }

  solicitaApartadoConEnvio(data:any){
    this.setHeaders()
    return this.http.post<any>(`${environment.apiUrl}/api/solicitaApartadoConEnvio`, data, {headers: this.headers})
  }

  confirmarVenta(data:any){
    this.setHeaders()
    return this.http.post<any>(`${environment.apiUrl}/api/confirmarVenta`, data, {headers: this.headers})
  }

  confirmarVentaConEnvio(data:any){
    this.setHeaders()
    return this.http.post<any>(`${environment.apiUrl}/api/confirmaVentaConEnvio`, data, {headers: this.headers})
  }

  solicitaCancelacionApartado(data:any){
    this.setHeaders()
    return this.http.post<any>(`${environment.apiUrl}/api/solicitaCancelacionApartado`, data, {headers: this.headers})
  }

  getHistorialCompras(data:any){
    this.setHeaders()
    return this.http.get<any>(`${environment.apiUrl}/api/getHistorialCliente/${data.token}/${data.idCliente}`, {headers: this.headers})
  }

  getHistorialComprasConEstatus(data:any){
    this.setHeaders()
    return this.http.get<any>(`${environment.apiUrl}/api/getHistorialClienteConEstatus/${data.token}/${data.idCliente}`, {headers: this.headers})
  }

  getCostoEnvioADomicilio(data:any){
    this.setHeaders()
    return this.http.get<any>(`${environment.apiUrl}/api/getAppCostoDeEnvio/${data.token}/${data.idSucursal}`, {headers: this.headers})
  }

  getPromocionesVigentesPorSucursal (data:any){
    this.setHeaders()
    return this.http.get<any>(`${environment.apiUrl}/api/getPromocionesVigentesPorSucursal/${data.token}/${data.idSucursal}`, {headers: this.headers})
  }

  getPuntosPorUsuario(data:any){
    this.setHeaders()
    return this.http.get<any>(`${environment.apiUrl}/api/getPuntosPorUsuario/${data.token}/${data.idCliente}`, {headers: this.headers})
  }

  determinaTipoDeVehiculo(data:any){
    this.setHeaders()
    return this.http.post<any>(`${environment.apiUrl}/api/determinaTipoDeVehiculo`, data, {headers: this.headers})
  }

  confirmarVentaConEnvioYPuntos(data:any){
    this.setHeaders()
    return this.http.post<any>(`${environment.apiUrl}/api/confirmaVentaConEnvioYPuntos`, data, {headers: this.headers})
  }
  
  getProductosDisponiblesConPuntos(data:any){
    this.setHeaders()
    return this.http.get<any>(`${environment.apiUrl}/api/getProductosDisponiblesConPuntos/${data.idCliente}`, {headers: this.headers})
  }

  getPromocionesVigentes(data:any){
    this.setHeaders()
    return this.http.get<any>(`${environment.apiUrl}/api/getPromocionesVigentes/${data.token}`, {headers: this.headers})
  }

  getPromocionesVigentesPorUsuario(data:any){
    this.setHeaders()
    return this.http.get<any>(`${environment.apiUrl}/api/getPromocionesVigentes/${data.token}/${data.idCliente}`, {headers: this.headers})
  }

  getPromocionesVigentesEnUnaSucursal(data:any){
    this.setHeaders()
    return this.http.get<any>(`${environment.apiUrl}/api/getPromocionesVigentesEnUnaSucursal/${data.token}/${data.idSucursal}/${data.idCliente}`, {headers: this.headers})
  }
  
  getPromocionesVigentesPorSucursalParaCliente(data:any){
    this.setHeaders()
    return this.http.get<any>(`${environment.apiUrl}/api/getPromocionesVigentesPorSucursal/${data.token}/${data.idCliente}`, {headers: this.headers})
  }

  getSucursalesQuePuedenOfrecerUnaPromocion(data:any){
    this.setHeaders()
    return this.http.get<any>(`${environment.apiUrl}/api/getSucursalesQuePuedenOfrecerUnaPromocion/${data.token}/${data.idPromo}/${data.idCliente}`, {headers: this.headers})
  }

  // Tipo 1
  getProductosPromoPRPorSucursal(data:any){
    this.setHeaders()
    return this.http.get<any>(`${environment.apiUrl}/api/getProductosPromoPRPorSucursal/${data.idOferta}/${data.Cantidad}/${data.idSucursal}`, {headers: this.headers})
  }

  getProductosPromoPRPorSucursalLista(data:any){
    this.setHeaders()
    return this.http.get<any>(`${environment.apiUrl}/api/getProductosPromoPRPorSucursalLista/${data.idOferta}/${data.idSucursal}`, {headers: this.headers})
  }

  // Tipo 2
  getProductosPromoDDPorSucursal(data:any){
    this.setHeaders()
    return this.http.get<any>(`${environment.apiUrl}/api/getProductosPromoDDPorSucursal/${data.idOferta}/${data.idSucursal}`, {headers: this.headers})
  }

  // Tipo 3
  getProductosPromoDCPorSucursal(data:any){
    this.setHeaders()
    return this.http.get<any>(`${environment.apiUrl}/api/getProductosPromoDCPorSucursal/${data.idOferta}/${data.idSucursal}`, {headers: this.headers})
  }

  getProductosPromoDCPorSucursalLista(data:any){
    this.setHeaders()
    return this.http.get<any>(`${environment.apiUrl}/api/getProductosPromoDCPorSucursalLista/${data.idOferta}/${data.idSucursal}`, {headers: this.headers})
  }

  // Tipo 4
  getProductosPromoVAPorSucursal(data:any){
    this.setHeaders()
    return this.http.get<any>(`${environment.apiUrl}/api/getProductosPromoVAPorSucursal/${data.idOferta}/${data.idSucursal}`, {headers: this.headers})
  }

  // Tipo 5
  getProductosPromoREPorSucursal(data:any){
    this.setHeaders()
    return this.http.get<any>(`${environment.apiUrl}/api/getProductosPromoREPorSucursal/${data.idOferta}/${data.idSucursal}`, {headers: this.headers})
  }

  getProductosPromoREPorSucursalLista(data:any){
    this.setHeaders()
    return this.http.get<any>(`${environment.apiUrl}/api/getProductosPromoREPorSucursalLista/${data.idOferta}/${data.idSucursal}`, {headers: this.headers})
  }

  // Tipo 6 - Productos Gratis
  crearCodigoPromocional(data:any){
    this.setHeaders()
    return this.http.get<any>(`${environment.apiUrl}/api/crearCodigoPromocion/${data.idCliente}/${data.idPromocion}/${data.codigoCanje}/${data.fechaExpiracion}`, {headers: this.headers})
  }

  getProductosPromoCOPorSucursal(data:any){
    this.setHeaders()
    return this.http.get<any>(`${environment.apiUrl}/api/getProductosPromoCOPorSucursal/${data.idOferta}/${data.idSucursal}/${data.idCliente}`, {headers: this.headers})
  }

  canjearCodigoPromocion(data:any){
    this.setHeaders()
    return this.http.get<any>(`${environment.apiUrl}/api/canjearCodigoPromocion/${data.idCliente}/${data.idPromocion}/${data.CodigoCanje}`, {headers: this.headers})
  }

  solicitaApartadoConEnvioPromo(data:any){
    this.setHeaders()
    return this.http.post<any>(`${environment.apiUrl}/api/solicitaApartadoConEnvioPromo`, data, {headers: this.headers})
  }

  confirmaVentaConEnvioYPuntos(data:any){
    this.setHeaders()
    return this.http.post<any>(`${environment.apiUrl}/api/confirmaVentaConEnvioYPuntos`, data, {headers: this.headers})
  }

  permisoParaAceptarCodigoCanjeProductoGratis(data:any){
    this.setHeaders()
    return this.http.get<any>(`${environment.apiUrl}/api/permisoParaAceptarCodigoCanjeProductoGratis/${data.idCliente}/${data.idPromocion}/${data.CodigoCanje}`, {headers: this.headers})
  }

  insertaModificaCliente(data:any){
    this.setHeaders()
    return this.http.post<any>(`${environment.apiUrl}/api/insertaModificaCliente`, data, {headers: this.headers})
  }

  insertaModificaClienteV2(data:any){
    this.setHeaders()
    return this.http.post<any>(`${environment.apiUrl}/api/insertaModificaClienteV2`, data, {headers: this.headers})
  }

  getBoletos(data:any){
    this.setHeaders()
    return this.http.post<any>(`${environment.apiUrl}/api/obtenerBoletosPromocion`, data, {headers: this.headers})
  }

  setHeaders(){
    if(this.cookieService.get('UL')){
      this.headers = new HttpHeaders({
        'Accept':'application/json',
        'x-api-key': environment.apiKey,
        'X-User-Phone': localStorage.getItem('userPhone') ?? ''
      })
    }
    else{
      this.headers = new HttpHeaders({
        'Accept':'application/json',
        'x-api-key': environment.apiKey
      })
    }
  }
}
